module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Fahrenheit-b0e52b6c5b9834029dfc556c188383cf.svg";